import { render } from "./FieldDetailsBlock.vue?vue&type=template&id=5514abba"
import script from "./FieldDetailsBlock.vue?vue&type=script&lang=js"
export * from "./FieldDetailsBlock.vue?vue&type=script&lang=js"

import "./FieldDetailsBlock.vue?vue&type=style&index=0&id=5514abba&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__